import { render, staticRenderFns } from "./linYun.vue?vue&type=template&id=2d0ee844&scoped=true&"
import script from "./linYun.vue?vue&type=script&lang=js&"
export * from "./linYun.vue?vue&type=script&lang=js&"
import style0 from "./linYun.vue?vue&type=style&index=0&id=2d0ee844&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0ee844",
  null
  
)

export default component.exports